import { render, staticRenderFns } from "./RoundedCard.vue?vue&type=template&id=78d5de9f&scoped=true&"
import script from "./RoundedCard.vue?vue&type=script&lang=js&"
export * from "./RoundedCard.vue?vue&type=script&lang=js&"
import style0 from "./RoundedCard.vue?vue&type=style&index=0&id=78d5de9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d5de9f",
  null
  
)

export default component.exports